import { PartnerReviewRejectionReasonType } from 'src/constants/rejectionReason'
import { RejectionReason } from 'src/interfaces/rejectionReason'
import { State } from 'src/reducers/types'

export const getRejectionReasons = (state: State): Array<RejectionReason> =>
  state.rejectionReason.rejectionReasons
export const getDefaultRejectionReasons = (state: State): Array<RejectionReason> => {
  const rejectionReasons = getRejectionReasons(state)

  return rejectionReasons.filter(
    (reason) => reason.type === PartnerReviewRejectionReasonType.Default,
  )
}
export const getCustomRejectionReasons = (state: State): Array<RejectionReason> => {
  const rejectionReasons = getRejectionReasons(state)

  return rejectionReasons.filter(
    (reason) => reason.type === PartnerReviewRejectionReasonType.Custom,
  )
}

export const getRejectionReasonsToDecline = (state: State): Array<RejectionReason> =>
  state.rejectionReason.rejectionReasonsToDecline
